package tta.destinigo.talktoastro.feature_call_consultation.persentation.call_bottom_sheet_info

import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import co.touchlab.kermit.Logger
import tta.destinigo.talktoastro.feature_call_consultation.persentation.call_starter.CallInfoSuccessBottomSheet
import tta.destinigo.talktoastro.feature_call_consultation.persentation.widget.LowOnFreeCallConsultation
import tta.destinigo.talktoastro.shared.data.RechargeData
import tta.destinigo.talktoastro.feature_call_consultation.persentation.expert_busy.ErrorBottomSheetCallConsultation
import tta.destinigo.talktoastro.feature_call_consultation.persentation.widget.CallRechargeNowDialog
import tta.destinigo.talktoastro.shared.persentation.LoadingProgressDialog


@Composable
fun CallConsultationBottomSheet(
    component: CallConsultationComponent
) {

    val state by component.state.collectAsState()

    when (val currentState = state) {

        is CallInfoBottomSheetState.Loading -> {
            if (currentState.isLoading) {
                LoadingProgressDialog { }
            }
        }

        is CallInfoBottomSheetState.NormalCallLowBalance -> {
            CallRechargeNowDialog(
                rechargeData = currentState.rechargeData,
                onDismissRequest = {
                    component.onClosePage()
                },
                data = currentState.data,
                onRechargeSelected = { selectedAmount ->
                    Logger.d("selected amount - $selectedAmount")
                    component.event(CallConsultationEvent.OnNavigateRechargeCheckOut(selectedAmount))
                }
            )
        }

        is CallInfoBottomSheetState.CallInfoSuccess -> {
            CallInfoSuccessBottomSheet(
                consultationComponent = component,
                callDurationData = currentState.data,
                onDismiss = {
                    component.onClosePage()
                }
            )
        }

        is CallInfoBottomSheetState.Error -> {
            ErrorBottomSheetCallConsultation(msg = currentState.msg, onDismiss = { component.onClosePage()},component)
        }

        is CallInfoBottomSheetState.FreeCallLowBalance -> {

            val planData = RechargeData(
                amount = currentState.data.plan_amount,
                id = currentState.data.planId,
                planName = currentState.data.plan_name,
                null
            )

            LowOnFreeCallConsultation(
                modifier = Modifier,
                expertName = component.expertInfo.expertName,
                expertSkills = component.expertInfo.expertSkills.toString(),
                expertImage = component.expertInfo.expertProfileImageUrl.toString(),
                callDurationData = currentState.data,
                onSubmit = {
                    component.event(CallConsultationEvent.OnNavigateRechargeCheckOut(planData))
                },
                onDismiss = {
                    component.onClosePage()
                }
            )
        }
    }
}
